import { render } from "./StatisticsCom.vue?vue&type=template&id=44fe5d83&scoped=true"
import script from "./StatisticsCom.vue?vue&type=script&lang=js"
export * from "./StatisticsCom.vue?vue&type=script&lang=js"

import "./StatisticsCom.vue?vue&type=style&index=0&id=44fe5d83&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fe5d83"]])

export default __exports__